<template>
    <div>
        <Row>
        <i-col span="22">
            
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add"  v-if="privilegesbtn('/company/service_set')">配置</Button>  
        </i-col>
    </Row>
    <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>

    </div>
</template>
<script>
import { company_service_index } from "../../api/companyapi";
import privilegesbtn from "../../constant/privilegesbtn.js";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      company_id: "",
      tableColumns: [
        {
          title: "集团名称",
          key: "company_name",
          align: "center"
        },
        {
          title: "服务代码",
          key: "code",
          align: "center"
        },
        {
          title: "服务名称",
          key: "name",
          align: "center"
        },
        {
          title: "客房可用",
          key: "room",
          align: "center",
          render: (h, params) => {
            var rel = params.row.room == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
        {
          title: "餐饮可用",
          key: "food",
          align: "center",
          render: (h, params) => {
            var rel = params.row.food == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
        {
          title: "线上支付",
          key: "money",
          align: "center",
          render: (h, params) => {
            var rel = params.row.money == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        },
        {
          title: "服务默认配置",
          key: "config",
          align: "center"
        },
        {
          title: "是否可用",
          key: "isvalid",
          align: "center",
          render: (h, params) => {
            var rel = params.row.isvalid == 0 ? "不可用" : "可用";
            return h("span", rel);
          }
        }
      ]
    };
  },
  methods: {
    privilegesbtn: privilegesbtn,
    mockTableData() {
      let para = {
        company_id: this.company_id
      };
      this.$Loading.start();
      company_service_index(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        // this.total = Data.data.total;
        this.tableData = Data.data;
        this.tableData.forEach(item=>{
            item.company_name=this.company_name
        })
      });
    },
    add() {
      var data = this.tableData;
      var param = [];
      data.forEach(item => {
        param.push(item.code);
      });
      this.$router.push({
        path: "/serviceset",
        query: {
          data: JSON.stringify(param),
          company_id: this.company_id,
          company_name:this.company_name
        }
      });
    },
    adminlist(param) {
      var query = { id: param };
      openpage("companyadmin", query);
    },
    changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.id)
      this.company_id = this.$route.query.id;
      this.company_name=this.$route.query.name
    this.mockTableData();
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/company/servicelist.vue